// extracted by mini-css-extract-plugin
export var container = "PreviewSolution-module--container--47315";
export var content = "PreviewSolution-module--content--3d868";